(function () {
  if (window.numbRewardsBound) return;
  window.numbRewardsBound = true;

  function previewCartUrl() {
    const query = new URLSearchParams(location.search);
    const preview = query.get('preview_theme_id');
    if (preview) sessionStorage.setItem('numb_preview_theme_id', preview);
    const themeId = preview || sessionStorage.getItem('numb_preview_theme_id');
    return themeId ? '/cart?preview_theme_id=' + encodeURIComponent(themeId) : '/cart';
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-numb-gift]');
    if (!button) return;
    event.preventDefault();
    const container = button.closest('[data-numb-rewards]');
    const error = container && container.querySelector('.numb-rewards__error');
    const tank = button.dataset.numbGift === 'tank';
    const id = tank ? container.querySelector('[data-numb-tank-size]')?.value : button.dataset.bundle;
    if (!id) {
      if (error) { error.textContent = 'Please choose an available gift.'; error.hidden = false; }
      return;
    }
    button.disabled = true;
    const previousText = button.textContent;
    button.textContent = 'Adding gift…';
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1, properties: { _numb_gift: tank ? 'tank' : 'gear' } }] })
      });
      if (!response.ok) {
        const details = await response.json().catch(function () { return {}; });
        throw new Error(details.description || 'This gift is unavailable. Please try another option.');
      }
      const redirect = previewCartUrl();
      location.assign('/discount/' + (tank ? 'NUMB90TANK' : 'NUMB90GEAR') + '?redirect=' + encodeURIComponent(redirect));
    } catch (failure) {
      if (error) { error.textContent = failure.message; error.hidden = false; }
      button.disabled = false;
      button.textContent = previousText;
    }
  });

  const banner = document.getElementById('NumbHomeRewards');
  if (!banner) return;
  const header = document.getElementById('header');
  function setHeaderOffset() {
    banner.style.setProperty('--numb-header-height', (header ? Math.ceil(header.getBoundingClientRect().height) : 0) + 'px');
  }
  setHeaderOffset();
  window.addEventListener('resize', setHeaderOffset);
  if (header && window.ResizeObserver) new ResizeObserver(setHeaderOffset).observe(header);
  const shipping = banner.querySelector('[data-numb-ship]');
  const gift = banner.querySelector('[data-numb-gift-progress]');
  const message = banner.querySelector('[data-numb-home-message]');
  const progressBar = banner.querySelector('[role="progressbar"]');
  const dollars = function (cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); };
  let timer;

  async function updateBanner() {
    try {
      const response = await fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      const subtotal = cart.items.reduce(function (sum, item) {
        const giftItem = item.properties && item.properties._numb_gift;
        if (giftItem || [7230442700843, 7172571889707].includes(item.product_id)) return sum;
        return sum + item.original_line_price;
      }, 0);
      shipping.style.setProperty('--reward-progress', Math.min(subtotal / 6000, 1));
      gift.style.setProperty('--reward-progress', Math.max(0, Math.min((subtotal - 6000) / 3000, 1)));
      shipping.classList.toggle('is-met', subtotal >= 6000);
      gift.classList.toggle('is-met', subtotal >= 9000);
      progressBar.setAttribute('aria-valuenow', Math.min(Math.round(subtotal / 100), 90));
      message.textContent = subtotal < 6000
        ? 'Add ' + dollars(6000 - subtotal) + ' for free U.S. shipping'
        : subtotal < 9000
          ? 'Free shipping unlocked · Add ' + dollars(9000 - subtotal) + ' for a gift'
          : 'Free shipping + gift unlocked · Choose your gift in the cart';
    } catch (_) { /* Keep the banner visible if cart retrieval is unavailable. */ }
  }

  function scheduleUpdate() {
    clearTimeout(timer);
    timer = setTimeout(updateBanner, 250);
  }
  updateBanner();
  const drawer = document.getElementById('Cart-Drawer');
  if (drawer) new MutationObserver(scheduleUpdate).observe(drawer, { childList: true, subtree: true, characterData: true });
  document.addEventListener('cart:updated', scheduleUpdate);
  document.addEventListener('cart:refresh', scheduleUpdate);
})();